// @flow
import React from 'react';
import Flex from '@waglabs/flex';

import { AppDownloadBlock } from './components/AppDownloadBlock';
import { FooterLinks } from './components/FooterLinks/FooterLinks';
import footerData from './footerData';

export const Footer = () => (
  <Flex
    flexDirection={['column-reverse', 'column-reverse', 'row']}
    width={[1]}
    maxWidth={1600}
    overflow="hidden"
    boxSizing="border-box"
    justifyContent={['flex-start', 'center']}
    alignItems={['flex-start', 'center']}
    flexShrink="0"
  >
    <FooterLinks
      data={footerData}
    />
    <AppDownloadBlock />
  </Flex>
);
